/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import WalletItem from './WalletItem';

const WalletCard = ({ wallet, index, fiatCurrencyCode, onAddFundsClick }) => (
  <Draggable draggableId={wallet.id} index={index}>
    {(provided, snapshot) => (
      <WalletItem
        onClick={onAddFundsClick}
        isDragging={snapshot.isDragging}
        dragProps={provided}
        wallet={wallet}
        fiatCurrencyCode={fiatCurrencyCode}
      />
    )}
  </Draggable>
);

export default WalletCard;

WalletCard.propTypes = {
  wallet: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onAddFundsClick: PropTypes.func.isRequired,
  fiatCurrencyCode: PropTypes.string,
};

WalletCard.defaultProps = {
  fiatCurrencyCode: null,
};
